/**
 * Text preparation shared by every markdown surface.
 *
 * The agent persists interactive-control payloads (the clarify questions) as
 * HTML comments inside the assistant message, because the same string is
 * replayed to the model as conversation history on the next turn. Hiding them
 * used to rely on react-markdown dropping `html` nodes when rehype-raw is
 * absent - an incidental property of the render pipeline, not a guarantee, and
 * one that failed in production: the raw marker rendered into the chat.
 *
 * Stripping them here makes it explicit and testable. It also covers the
 * UNTERMINATED comment a streaming turn produces, where the opener has arrived
 * and the closer has not.
 */
const HTML_COMMENT = /<!--[\s\S]*?-->/g;
const UNTERMINATED_HTML_COMMENT = /<!--[\s\S]*$/;

export function stripHtmlComments(markdown) {
  if (typeof markdown !== 'string' || !markdown) return '';
  return markdown.replace(HTML_COMMENT, '').replace(UNTERMINATED_HTML_COMMENT, '').trim();
}
